import styled from 'styled-components';

const Content = styled.div`
  display: flex;
  align-items: flex-start;
`;

export default Content;
